import { render, staticRenderFns } from "./DCSettle.vue?vue&type=template&id=30d6d20c&scoped=true&"
import script from "./DCSettle.vue?vue&type=script&lang=js&"
export * from "./DCSettle.vue?vue&type=script&lang=js&"
import style0 from "./DCSettle.vue?vue&type=style&index=0&id=30d6d20c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d6d20c",
  null
  
)

export default component.exports